import {
  gql
} from "@apollo/client"

const MiniCartFrequentlyBoughtTogetherProductFragment = gql`
  fragment MiniCartFrequentlyBoughtTogetherProductFragment on Products {
    items {
      id
      uid
      name
      version
      price_range {
        maximum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
        minimum_price {
          final_price {
            currency
            value
          }
          regular_price {
            currency
            value
          }
          discount {
            amount_off
          }
        }
      }
      sku
      image {
        url(type: "thumbnail", width: 692, height: 1016)
      }
      hover_image(width: 692, height: 1016)
      __typename
      url_key
    }
  }
`

export const GET_MINI_CART_FREQUENTLY_BOUGHT_PRODUCTS = gql`
  query GetMiniCartFrequentlyBoughtProducts($urlKeys:[String]){
     products(filter: { url_key: { in: $urlKeys } }){
       ...MiniCartFrequentlyBoughtTogetherProductFragment
    }
  }

  ${MiniCartFrequentlyBoughtTogetherProductFragment}
`
